// extracted by mini-css-extract-plugin
export var bold = "_re-0";